let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dzfxi")).then(() => parcelRequire('g3kRp'));